<template>
    <section id="page-container-red">
        <Navbar/>
        <div class="calltoaction">
            <p class="text-white text-center" style="font-size:1.3em"><strong>Join seasoned businessmen and women in exciting debate about the future of the continent</strong></p><section class="row">
                <Spinner v-if="isLoading" :color="'text-light'" />
                <div class="col-sm-9 col-md-8 col-lg-8 blog-main my-3 " v-if="!isLoading">
                    <div class="text-center mb-3">
                        <button @click="verifyUser" type="button" class="btn btn-warning text-light btn-lg " data-toggle="modal" data-target="#exampleModalCenter">Upload new Debate Topic</button>
                  </div>
                <div class="col-xs-12 col-sm-12 py-3"
                    v-for="(debate,key) in debateArticle" :key="key">
                    <DebateCard :debate="debate"/>
                </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3 col-sm-offset-1 blog-sidebar">
                    <DebateSidebar/>
                </div>
            </section>
        </div>
        <!--  -->
         <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">New Debate</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-success" v-if="success">
                            <p>Thank you for submitting your debate article with us.</p>
                            <p>Our team will review and if it meets our standard, it will be approved</p>
                        </div>
                        <form v-if="!success">
                            
                            <div class="form-group">
                                <label for="topic">Article Title <strong class="text-danger">(required)</strong></label>
                                <input type="text" class="form-control" placeholder="Enter debate title"  required v-model="title">
                            </div>
                         <div class="form-group">
                           <label for="basic-url">Upload your picture (optional)</label>
                            <div class="custom-file">
                            <input accept="image/*" type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadImage" >
                            <label class="custom-file-label" for="validatedCustomFile">
                               {{picTitle ? picTitle :"Choose file..."}}
                            </label>
                           <small v-if="error" class="form-text text-danger">your picture size shouldn't be more than 1MB</small>
                        </div>
                       </div>
                            <div class="form-group">
                                <label for="description">Description <strong class="text-danger">(required)</strong></label>
                                <textarea  name="description" 
                                    class="form-control" rows="15" required placeholder="Enter description" v-model="description">
                                    </textarea>
                                    <!-- <small class="text-danger">Description should be 100 words or less</small> -->
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-if="!success"  @click="addDebate" :disabled="!description || !title" type="submit" class="btn btn-primary">Submit</button>
                    </div>
                    </div>
                </div>
                </div>
    </section>
</template>

<script>
/* allow-no-unused-vars */
import Navbar from './appBar'
import toasterMixin from '../mixins/toasterMinxin'
import DebateCard from './debateCard'
import DebateSidebar from './debateSidebar'

import url from './../helpers/url'
import service from './../helpers/service'
import Spinner from '../components/Spinner'
    export default {
        components:{
            Navbar,
            DebateCard,
            DebateSidebar,
            Spinner
        },
    data() {
        return {
            title:'',
            description:'',
            pic:'',
            picTitle:'',
            success:false,
            isLoading:false,
            error:false
        }
    },
    methods:{
         uploadImage(event) {
                this.pic = event.target.files
                this.picTitle = this.pic[0].name   
                if(this.pic) {
                    let size
                    for( let i = 0; i < this.pic.length; i++) {
                       size  = Math.round(( this.pic[i].size  / 1024)); 
                    }
                    if( size > 2048) {
                        this.error = true
                        this.toast({
                            message:'picture Size is too big',
                            type:'error'
                        })
                        return;
                    }
                    
                }
            },
        addDebate() { 
            const data = {
                topic:this.title,
                body:this.description
            }
            const formData = new FormData()
            
            formData.append('topic', this.title)
            formData.append('body', this.description)

             

            if(this.pic) {
                    for( let i = 0; i < this.pic.length; i++) {
                        formData.append('pic', this.pic[i])
                    }
                } else {
                    formData.append('pic', '')
                }
            // 
            this.$store.dispatch('addNewDebateArticle',formData)
                .then(response => {
                    if(response) {
                        this.success = true
                        this.title = null
                        this.description = null
                        // this.toast({
                        //     message:'Debate article added successfully.',
                        //     type:'success'
                        // })
                    }
                     
                    if(err?.response?.data == undefined) {
                        this.toast({
                            message:'Network error. Check your network and try again.',
                            type:'error'
                        })
                    }
                })
        },
        verifyUser() {
            this.success = false
            const user = this.$session.get('entity')
            if(!user) {
                window.location.replace(`/redirect?service=login`)
            }
        },
        fetchDebateArticle() {
            this.isLoading = true
             this.$store.dispatch('fetchApprovedDebateArticle').then(response => 
             {
                 if(response) {
                     this.isLoading = false
                 }
             }).catch(err => {
                 this.isLoading = false
                 if(err?.response?.data === undefined) {
                     this.isLoading = false
                 }
             })
        }
    },
    computed: {
        debateArticle() {
            return this.$store.getters.debateArticle
        }
    },
    created() {
        // document.querySelector('body').setAttribute('style', 'background-color:#ba2428')
       this.fetchDebateArticle()
        
    },
    // beforeDestroy() {
    //     document.querySelector('body').removeAttribute('style')
    // },
    }
</script>

<style >

.calltoaction{
    padding-top: 150px;
}
.card-user {
  position: absolute;
  right: 10px;
  top: 10px;
}
.card-category {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
}
section{
    background-color:#ba2428 !important;
}

</style>